import * as React from 'react';
import { styled } from 'styled-components';

const MobileSummaryCellItem = (props: Props) => {
	return (
		<div key={props.value}>
			<CellHead>{props.title ? `${props.title}: ` : ''}</CellHead>
			<span>{props.value ?? ''}</span>
		</div>
	);
};

export default MobileSummaryCellItem;

interface Props {
	title?: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	value: any;
}

export const CellHead = styled.span`
	font-weight: bold;
`;
